export const environment = {
    production: false,
    eu: false,
    apiUrl: '/api/',
    envSuffix: '',


    googleCfg: {
        authdomain: 'www.compliant-now-staging.com'
    },

    azureLoginCfg: {
        clientId: '785aea2e-ec24-4970-8d96-fb72e9cb7d80', // This is your application ID
        authority: 'https://login.microsoftonline.com/common', // This depends on users accepted, this configuration is for all kinds and all orgs
        redirectUri: 'https://www.compliant-now-staging.com'// This is your redirect URI  
    }
};
